// extracted by mini-css-extract-plugin
module.exports = {"table":"up-record_table_lOE45","img":"up-record_img_1g0C7"};